<template>
  <div
    data-slick-slider
    data-slick-slider-autoplay="true"
    data-slick-slider-autoplay-timer="6000"
    class="accouncement-bar--container"
    id="announcement-container"
  >
    <div
      :key="index"
      v-for="(data, index) in computedData"
      class="slick-slide slick-slide-settings"
    >
      <a :href="data.link" class="link dib dim">
        <span class="pxs-announcement-bar-text-mobile" v-html="data.text">
        </span>
        <span class="pxs-announcement-bar-text-desktop" v-html="data.text">
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "announcement-cart",
  props: {
    anouncements: {
      type: Array,
      default: [],
    },
  },
  computed: {
    computedData() {
      return this.anouncements.length
        ? this.anouncements
        : window.Shopify.announcement || [];
    },
  },
};
</script>
